import { EnvBase } from '@bcf2-envs/types';
import { EnvCommon } from './types';

export function envCommonToLit20EnvBase(envCommon: EnvCommon): EnvBase {
  return {
    availableLangs: envCommon.langs,
    baseDomainName: envCommon.baseDomainName,
    brandInfo: {
      brandName: envCommon.brandInfo.brandName
    }
  };
}
